// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Product_container__Nk0ii {
  flex: 1 1;
  max-width: 1140px;
  margin: 0 auto;
  padding-top: 60px;
  margin-top: 10px;
}

.Product_productDetails__C4459 {
  display: flex;
  gap: 20px;
}

.Product_imageGallery__SvH5U {
  flex: 7 1; /* 70% */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Product_imageFrame__teIj4 {
  width: 80%; /* Dimensiunea totală a ramei */
  aspect-ratio: 1; /* Păstrează proporția pătrată */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative; /* Poziționare relativă pentru săgețile interne */
  background-color: #fff; /* Fundal alb */
  margin: 0 auto;
}

.Product_mainImage__NeTzk {
  width: 80%; /* Dimensiunea imaginii principale redusă cu 10% */
  height: auto;
  object-fit: contain; /* Centrare și proporții corecte */
}

.Product_arrowLeft__DHWaF,
.Product_arrowRight__Nvs9u {
  position: absolute;
  top: 50%; /* Poziționat la mijlocul ramei */
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  color: #979797;
}

.Product_arrowLeft__DHWaF {
  left: 10px; /* Săgeata este acum în interiorul ramei */
}

.Product_arrowRight__Nvs9u {
  right: 10px; /* Săgeata este acum în interiorul ramei */
}

.Product_arrowLeft__DHWaF:hover,
.Product_arrowRight__Nvs9u:hover {
  color: rgba(0, 0, 0, 0.7); /* Fundal mai opac la hover */
}

.Product_thumbnailContainer__qHM26 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 10px;
}

.Product_thumbnail__oya0g {
  width: 60px;
  height: 60px;
  margin: 0 5px;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 8px; /* Adaugă colțuri rotunjite */
  transition: border-color 0.3s, opacity 0.3s; /* Efect de tranziție pentru bordură și transparență */
  opacity: 0.5; /* Miniaturile sunt mai palide implicit */
}

.Product_thumbnail__oya0g:hover {
  border-color: #ff0000; /* Roșu la hover */
}

.Product_activeThumbnail__lH0t1 {
  border-color: #ff0000; /* Roșu pentru miniatura activă */
  opacity: 1; /* Miniatura activă este complet vizibilă */
  border-radius: 4px; /* Colțuri rotunjite pentru rama activă */
}

.Product_productInfo__gGwCr {
  flex: 3 1; /* 30% */
}

.Product_powerSelection__MrFgV {
  margin-top: 20px;
}

.Product_powerSelection__MrFgV h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

.Product_powerSelection__MrFgV form {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.Product_powerSelection__MrFgV label {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: bold;
  padding: 2px 15px;
}

.Product_powerSelection__MrFgV input[type="radio"] {
  margin-right: 12px;
}

.Product_price__g\\+KRk {
  font-size: 24px;
  color: #000;
  margin: 10px 0;
  font-weight: bold;
  padding-left: 15px;
}

.Product_addToCart__4-tfq {
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  margin-top: 20px;
}

.Product_addToCart__4-tfq:hover {
  background-color: #0056b3;
}

.Product_tva__GqPmp {
  color: red;
  margin-top: 10px;
}

.Product_productDescription__xEIW9 {
  margin-top: 20px;
}

.Product_productDescription__xEIW9 p {
  margin: 0; /* Elimină spațiul dintre paragrafe */
  line-height: 1.4; /* Ajustează înălțimea liniei pentru a reduce spațiul */
}

.Product_productDescription__xEIW9 ul {
  margin: 0;
  padding-left: 40px; /* Spațiu pentru indentarea listei */
}

.Product_productDescription__xEIW9 li {
  margin: 0;
  line-height: 1.4; /* Ajustează distanța între linii */
}

.Product_checkPrices__gxu16 {
  color: green;
  margin-bottom: 10px;
  font-size: 16px;
}

.Product_separator__YiJ5A {
  border: none;
  border-top: 1px solid #ddd;
  margin: 15px 0;
}

.Product_descriptionText__iiiTP {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.Product_descriptionText__iiiTP p {
  color: #666;
  font-size: 16px;
}

.Product_guaranteeText__-E4GJ {
  color: #666;
  font-size: 16px;
  font-weight: bold;
}

.Product_priceLabel__n9ELB {
  font-size: 19px;
  font-weight: bold;
  color: gray;
  padding-top: 10px;
  margin-bottom: 5px;
}

.Product_features__mAfA8 {
  display: flex;
  flex-wrap: wrap; /* Permite elementelor să treacă pe următorul rând */
  justify-content: space-between;
  margin-top: 30px;
  gap: 20px;
}

.Product_featureCard__neCuO {
  flex: 1 1;
  text-align: center;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background-color: #fff;
}

.Product_icon__9xKJD {
  width: 60px;
  height: 60px;
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
  background-color: #ff0000;
}

.Product_icon__9xKJD i {
  margin-left: 4px;
}

.Product_rating__A0WPH {
  margin: 10px 0;
  font-size: 20px; /* Dimensiune mai mare pentru stele */
  color: #333; /* Aceeași culoare ca textul */
}

.Product_featureCard__neCuO h3 {
  font-size: 18px;
  margin: 10px 0;
  color: #333;
}

.Product_featureCard__neCuO p {
  font-size: 14px;
  color: #666;
}

.Product_guaranteeBox__Xv2pl {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.Product_guaranteeContent__PmTFk {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Product_guaranteeContent__PmTFk i {
  color: #ff6b6b; /* Culoarea iconiței */
  font-size: 24px;
}

.Product_guaranteeContent__PmTFk p {
  margin: 0;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.Product_productName__A\\+Y7Z {
  color: #ff0000; /* Culoare roșie pentru numele produsului */
  font-weight: bold;
}

.Product_name__6mBdh {
  font-size: 36px;
}

.Product_invalidProduct__SReaM {
  align-items: center;
  justify-content: center;
}

.Product_addToCartButton__s5OjF {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(231, 0, 0);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 12px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 16px;
}

.Product_addToCartButton__s5OjF:hover {
  background-color: #b71c1c;
}

.Product_addToCartButton__s5OjF:active {
  background-color: #a02626;
}

.Product_addToCartButton__s5OjF i {
  margin-right: 3px;
  font-size: 14px; /* Ajustează dimensiunea iconiței */
}

.Product_power__jvNPF {
  color: gray;
  font-size: 16px;
  font-weight: bold;
}

/* Responsive */
@media (max-width: 768px) {
  /* Câmpul de căutare */
  .Product_productDetails__C4459 {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .Product_container__Nk0ii {
    flex: 1 1;
    padding-top: 60px;
    margin: 10px;
  }

  .Product_powerCost__1QwBc {
    display: flex;
    flex-direction: row;
    width: 100%;
    box-sizing: content-box; /* 1 */
  }

  .Product_priceContainer__dn4Sc {
    display: flex;
    flex-direction: column;
    width: 50%;
  }

  .Product_powerSelection__MrFgV {
    margin-top: 0px;
    width: 50%;
  }

  .Product_priceLabel__n9ELB {
    font-size: 23px;
    font-weight: bold;
    color: gray;
    padding-top: 0px;
    margin-bottom: 5px;
  }

  .Product_power__jvNPF {
    font-size: 23px;
    font-weight: bold;
    color: gray;
    padding-top: 10px;
    margin-bottom: 5px;
  }

  .Product_price__g\\+KRk {
    font-size: 30px;
    color: #000;
    margin: 10px 0;
    font-weight: bold;
    padding-left: 15px;
  }

  .Product_addToCartButton__s5OjF {
    width: 100%;
    padding: 15px 0px;
  }

  .Product_features__mAfA8 {
    justify-content: center; /* Centrează elementele pe ecran mic */
    gap: 10px; /* Reduce spațiul dintre elemente */
  }

  .Product_featureCard__neCuO {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px); /* 50% lățime, minus gap pentru a evita suprapunerea */
    max-width: calc(50% - 50px); /* Asigură că nu depășește 50% */
  }

  .Product_arrowLeft__DHWaF,
  .Product_arrowRight__Nvs9u {
    position: static;
    top: 0%; /* Poziționat la mijlocul ramei */
    transform: translateY(-0%);
    color: rgba(0, 0, 0, 0.55); /* Fundal mai opac la hover */
  }
  .Product_arrowLeft__DHWaF:hover,
  .Product_arrowRight__Nvs9u:hover {
    color: rgba(0, 0, 0, 0.55); /* Fundal mai opac la hover */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Product/Product.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO,EAAE,QAAQ;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,+BAA+B;EAC3C,eAAe,EAAE,gCAAgC;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB,EAAE,iDAAiD;EACrE,sBAAsB,EAAE,eAAe;EACvC,cAAc;AAChB;;AAEA;EACE,UAAU,EAAE,kDAAkD;EAC9D,YAAY;EACZ,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ,EAAE,iCAAiC;EAC3C,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU,EAAE,0CAA0C;AACxD;;AAEA;EACE,WAAW,EAAE,0CAA0C;AACzD;;AAEA;;EAEE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,kBAAkB,EAAE,6BAA6B;EACjD,2CAA2C,EAAE,sDAAsD;EACnG,YAAY,EAAE,yCAAyC;AACzD;;AAEA;EACE,qBAAqB,EAAE,kBAAkB;AAC3C;;AAEA;EACE,qBAAqB,EAAE,iCAAiC;EACxD,UAAU,EAAE,2CAA2C;EACvD,kBAAkB,EAAE,yCAAyC;AAC/D;;AAEA;EACE,SAAO,EAAE,QAAQ;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS,EAAE,qCAAqC;EAChD,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,SAAS;EACT,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,SAAS;EACT,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,oDAAoD;EACrE,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe,EAAE,qCAAqC;EACtD,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,2CAA2C;EAC3D,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB,EAAE,MAAM;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,uBAAuB,EAAE,sCAAsC;IAC/D,SAAS,EAAE,mCAAmC;EAChD;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,sDAAsD;IAClF,2BAA2B,EAAE,gCAAgC;EAC/D;;EAEA;;IAEE,gBAAgB;IAChB,OAAO,EAAE,iCAAiC;IAC1C,0BAA0B;IAC1B,0BAA0B,EAAE,6BAA6B;EAC3D;EACA;;IAEE,0BAA0B,EAAE,6BAA6B;EAC3D;AACF","sourcesContent":[".container {\n  flex: 1;\n  max-width: 1140px;\n  margin: 0 auto;\n  padding-top: 60px;\n  margin-top: 10px;\n}\n\n.productDetails {\n  display: flex;\n  gap: 20px;\n}\n\n.imageGallery {\n  flex: 7; /* 70% */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.imageFrame {\n  width: 80%; /* Dimensiunea totală a ramei */\n  aspect-ratio: 1; /* Păstrează proporția pătrată */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative; /* Poziționare relativă pentru săgețile interne */\n  background-color: #fff; /* Fundal alb */\n  margin: 0 auto;\n}\n\n.mainImage {\n  width: 80%; /* Dimensiunea imaginii principale redusă cu 10% */\n  height: auto;\n  object-fit: contain; /* Centrare și proporții corecte */\n}\n\n.arrowLeft,\n.arrowRight {\n  position: absolute;\n  top: 50%; /* Poziționat la mijlocul ramei */\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  z-index: 10;\n  color: #979797;\n}\n\n.arrowLeft {\n  left: 10px; /* Săgeata este acum în interiorul ramei */\n}\n\n.arrowRight {\n  right: 10px; /* Săgeata este acum în interiorul ramei */\n}\n\n.arrowLeft:hover,\n.arrowRight:hover {\n  color: rgba(0, 0, 0, 0.7); /* Fundal mai opac la hover */\n}\n\n.thumbnailContainer {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.thumbnail {\n  width: 60px;\n  height: 60px;\n  margin: 0 5px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  border-radius: 8px; /* Adaugă colțuri rotunjite */\n  transition: border-color 0.3s, opacity 0.3s; /* Efect de tranziție pentru bordură și transparență */\n  opacity: 0.5; /* Miniaturile sunt mai palide implicit */\n}\n\n.thumbnail:hover {\n  border-color: #ff0000; /* Roșu la hover */\n}\n\n.activeThumbnail {\n  border-color: #ff0000; /* Roșu pentru miniatura activă */\n  opacity: 1; /* Miniatura activă este complet vizibilă */\n  border-radius: 4px; /* Colțuri rotunjite pentru rama activă */\n}\n\n.productInfo {\n  flex: 3; /* 30% */\n}\n\n.powerSelection {\n  margin-top: 20px;\n}\n\n.powerSelection h2 {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.powerSelection form {\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n}\n\n.powerSelection label {\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: bold;\n  padding: 2px 15px;\n}\n\n.powerSelection input[type=\"radio\"] {\n  margin-right: 12px;\n}\n\n.price {\n  font-size: 24px;\n  color: #000;\n  margin: 10px 0;\n  font-weight: bold;\n  padding-left: 15px;\n}\n\n.addToCart {\n  background-color: #007bff;\n  color: #fff;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.addToCart:hover {\n  background-color: #0056b3;\n}\n\n.tva {\n  color: red;\n  margin-top: 10px;\n}\n\n.productDescription {\n  margin-top: 20px;\n}\n\n.productDescription p {\n  margin: 0; /* Elimină spațiul dintre paragrafe */\n  line-height: 1.4; /* Ajustează înălțimea liniei pentru a reduce spațiul */\n}\n\n.productDescription ul {\n  margin: 0;\n  padding-left: 40px; /* Spațiu pentru indentarea listei */\n}\n\n.productDescription li {\n  margin: 0;\n  line-height: 1.4; /* Ajustează distanța între linii */\n}\n\n.checkPrices {\n  color: green;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n.separator {\n  border: none;\n  border-top: 1px solid #ddd;\n  margin: 15px 0;\n}\n\n.descriptionText {\n  color: #666;\n  font-size: 16px;\n  line-height: 1.6;\n  margin-bottom: 15px;\n}\n\n.descriptionText p {\n  color: #666;\n  font-size: 16px;\n}\n\n.guaranteeText {\n  color: #666;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.priceLabel {\n  font-size: 19px;\n  font-weight: bold;\n  color: gray;\n  padding-top: 10px;\n  margin-bottom: 5px;\n}\n\n.features {\n  display: flex;\n  flex-wrap: wrap; /* Permite elementelor să treacă pe următorul rând */\n  justify-content: space-between;\n  margin-top: 30px;\n  gap: 20px;\n}\n\n.featureCard {\n  flex: 1;\n  text-align: center;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  background-color: #fff;\n}\n\n.icon {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 24px;\n  background-color: #ff0000;\n}\n\n.icon i {\n  margin-left: 4px;\n}\n\n.rating {\n  margin: 10px 0;\n  font-size: 20px; /* Dimensiune mai mare pentru stele */\n  color: #333; /* Aceeași culoare ca textul */\n}\n\n.featureCard h3 {\n  font-size: 18px;\n  margin: 10px 0;\n  color: #333;\n}\n\n.featureCard p {\n  font-size: 14px;\n  color: #666;\n}\n\n.guaranteeBox {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.guaranteeContent {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.guaranteeContent i {\n  color: #ff6b6b; /* Culoarea iconiței */\n  font-size: 24px;\n}\n\n.guaranteeContent p {\n  margin: 0;\n  font-size: 14px;\n  color: #333;\n  line-height: 1.5;\n}\n\n.productName {\n  color: #ff0000; /* Culoare roșie pentru numele produsului */\n  font-weight: bold;\n}\n\n.name {\n  font-size: 36px;\n}\n\n.invalidProduct {\n  align-items: center;\n  justify-content: center;\n}\n\n.addToCartButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgb(231, 0, 0);\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 12px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-size: 16px;\n}\n\n.addToCartButton:hover {\n  background-color: #b71c1c;\n}\n\n.addToCartButton:active {\n  background-color: #a02626;\n}\n\n.addToCartButton i {\n  margin-right: 3px;\n  font-size: 14px; /* Ajustează dimensiunea iconiței */\n}\n\n.power {\n  color: gray;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  /* Câmpul de căutare */\n  .productDetails {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .container {\n    flex: 1;\n    padding-top: 60px;\n    margin: 10px;\n  }\n\n  .powerCost {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    box-sizing: content-box; /* 1 */\n  }\n\n  .priceContainer {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n  }\n\n  .powerSelection {\n    margin-top: 0px;\n    width: 50%;\n  }\n\n  .priceLabel {\n    font-size: 23px;\n    font-weight: bold;\n    color: gray;\n    padding-top: 0px;\n    margin-bottom: 5px;\n  }\n\n  .power {\n    font-size: 23px;\n    font-weight: bold;\n    color: gray;\n    padding-top: 10px;\n    margin-bottom: 5px;\n  }\n\n  .price {\n    font-size: 30px;\n    color: #000;\n    margin: 10px 0;\n    font-weight: bold;\n    padding-left: 15px;\n  }\n\n  .addToCartButton {\n    width: 100%;\n    padding: 15px 0px;\n  }\n\n  .features {\n    justify-content: center; /* Centrează elementele pe ecran mic */\n    gap: 10px; /* Reduce spațiul dintre elemente */\n  }\n\n  .featureCard {\n    flex: 0 1 calc(50% - 10px); /* 50% lățime, minus gap pentru a evita suprapunerea */\n    max-width: calc(50% - 50px); /* Asigură că nu depășește 50% */\n  }\n\n  .arrowLeft,\n  .arrowRight {\n    position: static;\n    top: 0%; /* Poziționat la mijlocul ramei */\n    transform: translateY(-0%);\n    color: rgba(0, 0, 0, 0.55); /* Fundal mai opac la hover */\n  }\n  .arrowLeft:hover,\n  .arrowRight:hover {\n    color: rgba(0, 0, 0, 0.55); /* Fundal mai opac la hover */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Product_container__Nk0ii`,
	"productDetails": `Product_productDetails__C4459`,
	"imageGallery": `Product_imageGallery__SvH5U`,
	"imageFrame": `Product_imageFrame__teIj4`,
	"mainImage": `Product_mainImage__NeTzk`,
	"arrowLeft": `Product_arrowLeft__DHWaF`,
	"arrowRight": `Product_arrowRight__Nvs9u`,
	"thumbnailContainer": `Product_thumbnailContainer__qHM26`,
	"thumbnail": `Product_thumbnail__oya0g`,
	"activeThumbnail": `Product_activeThumbnail__lH0t1`,
	"productInfo": `Product_productInfo__gGwCr`,
	"powerSelection": `Product_powerSelection__MrFgV`,
	"price": `Product_price__g+KRk`,
	"addToCart": `Product_addToCart__4-tfq`,
	"tva": `Product_tva__GqPmp`,
	"productDescription": `Product_productDescription__xEIW9`,
	"checkPrices": `Product_checkPrices__gxu16`,
	"separator": `Product_separator__YiJ5A`,
	"descriptionText": `Product_descriptionText__iiiTP`,
	"guaranteeText": `Product_guaranteeText__-E4GJ`,
	"priceLabel": `Product_priceLabel__n9ELB`,
	"features": `Product_features__mAfA8`,
	"featureCard": `Product_featureCard__neCuO`,
	"icon": `Product_icon__9xKJD`,
	"rating": `Product_rating__A0WPH`,
	"guaranteeBox": `Product_guaranteeBox__Xv2pl`,
	"guaranteeContent": `Product_guaranteeContent__PmTFk`,
	"productName": `Product_productName__A+Y7Z`,
	"name": `Product_name__6mBdh`,
	"invalidProduct": `Product_invalidProduct__SReaM`,
	"addToCartButton": `Product_addToCartButton__s5OjF`,
	"power": `Product_power__jvNPF`,
	"powerCost": `Product_powerCost__1QwBc`,
	"priceContainer": `Product_priceContainer__dn4Sc`
};
export default ___CSS_LOADER_EXPORT___;
